export const CLICK_ADD = 'CLICK_ADD';
export const CLICK_REMOVE = 'CLICK_REMOVE';
export const ORDER_BY = 'ORDER_BY';
